import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as $ from 'jquery';
import TagForm from '../../../components/authorised/patient/document/TagForm';
import { reset } from 'redux-form'
import {tagsLoad, tagLoad, tagCreate, tagUpdate, tagDelete, tagEdit, tagEditCancel} from '../../../redux/actions/patient/tagActions';
import { SaveButton } from '../../../itrust_common/components/others';
import Alert from '../../../itrust_common/components/Alert';

class Tags extends Component {
  constructor(props){
    super(props);
    this.handleTagsLoad({rpp:50});
    this.state = {
      activeTag: 'all'
    }
  }

  handleTagsLoad(filters){
    this.props.dispatch(tagsLoad(filters));
    // this.props.dispatch(filterChange({filters: filters}));
  }

  handleTagEdit(id){
    if (id !== 'New') this.props.dispatch(tagLoad(id));
    this.props.dispatch(tagEdit(id));
    $('#tagForm-modal').modal('show');
  }

  handleTagEditCancel(){
    this.props.dispatch(tagEditCancel());
    $('#tagForm-modal').modal('hide');
  }

  handleTagDelete(id){
    Alert.deleteConfirm("Are you sure? You want to delete this record.", 
    (response)=>{
      if(response)
        this.props.dispatch(tagDelete(id))
    })
  }

  handleTagSubmit(data) {
    const id = data.id || '';
    if (id === '') {
      this.props.dispatch(tagCreate(data));
    } else {
      this.props.dispatch(tagUpdate(data));
    }
  }

  componentDidUpdate() {
    if (!this.props.tagEditing){
      $('#tagForm-modal').modal('hide');
      this.props.dispatch(reset('tagForm'))
    }
  }
  // componentWillUnmount(){
  //   this.props.dispatch(filterReset());
  // }
  render() {
    const {tags, tagEditing, filters, saving, handlePatientDocumentsLoad, userType} = this.props
    return(
      <div className="col-12 px-0 py-5">
        <div className="d-flex flex-row align-items-center justify-content-between">
          {tagEditing && tagEditing.id === 'New' ? 
            [<h6>Manage Tags</h6>,
            <SaveButton buttonClasses="btn-sm float-right my-3"  label="Back" saving={saving} handleOnClick={this.handleTagEditCancel.bind(this)}/>]
            :
            [<h6>Filter document by tag</h6>,
            userType !== "Patient" && <button className="btn btn-link" onClick={this.handleTagEdit.bind(this, 'New')}>Manage Tags</button>]
          }
        </div>
        <div className="">
          {tags.map(tag => 
            <span 
              onClick={()=>{this.setState({activeTag: tag.name }); handlePatientDocumentsLoad({...filters, filter: { ...filters.filter, tag: tag.id }})}}
              className={`pointer badge badge-pill ${tagEditing && tagEditing.id === 'New' ? 'bg-dark text-white' : this.state.activeTag === tag.name ? 'bg-primary text-white':'bg-light'} m-3 d-inline-flex align-items-center `}>
              {tag.name}
              {tagEditing && tagEditing.id === 'New' && <i className="la la-sm la-times ml-2" onClick={this.handleTagDelete.bind(this, tag.id)}/>}
            </span>
          )}
        </div>
        {tagEditing && tagEditing.id === 'New' && 
          <div>
            <TagForm key={tags.length} onSubmit={this.handleTagSubmit.bind(this)}/>
          </div> 
        }
      </div>
    )
  }
}
const mapStateToProps = state => {
  const {tag, filter, auth} = state;
  return {
    tags: tag.tags,
    saving: tag.saving,
    tagEditing: tag.editing,
    filters: filter.filters,
    userType: auth.user.type
  }
}

export default connect(mapStateToProps)(Tags);